import React from "react";
import Classnames from "classnames";
import {
  toUpperCaseFirst,
  toLowerCaseFirst,
  matchAfterUrl,
  translateAlimentLibelle,
} from "../../../../../../../ReactConst";
import _ from "lodash";
import { withTranslation } from 'react-i18next';

class Proteines extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      showListAutre: false,
    };
    this.openListAutre = this.openListAutre.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeList = this.handleChangeList.bind(this);
    this.windowClick = this.windowClick.bind(this);
  }
  windowClick(event) {
    if (
      this.state.showMore &&
      !event.target.classList.contains("autre-react") &&
      !event.target.classList.contains("autre-plus")
    ) {
      this.setState({
        showListAutre: false,
        showMore: false,
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  componentDidMount() {
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
  }
  openListAutre() {
    this.setState((prevState) => ({ showListAutre: !prevState.showListAutre }));
  }
  handleChange = (proteine) => {
    if (proteine.id === "autre-composant-repas") {
      this.setState((prevState) => ({
        showMore: !prevState.showMore,
      }));
    } else {
      let data = { id: proteine.id, name: proteine.libelle };
      this.setState({ showMore: false });
      this.props.handleChangeProteines(data);
    }
  };
  handleChangeList = (proteine) => {
    let data = { id: proteine.id, name: proteine.libelle };
    this.props.handleChangeProteines(data);
  };
  render() {
    const { t } = this.props;
    if (!_.isEmpty(this.props.aliments.PROTEINES)) {
      const proteineArray = this.props.aliments.PROTEINES;
      return (
        <div className="tab-pane active" id="repas-legumes" role="tabpanel">
          <div className="row mx-n2 mb-4 d-flex align-items-center choices-objets objet-sante">
            {proteineArray.slice(0, 8).map((proteine) => (
              <div
                className="col-md-4 px-2"
                key={proteine.id}
                onClick={() => this.handleChange(proteine)}
              >
                <input
                  type="radio"
                  className="d-none"
                  id={proteine.id}
                  value={proteine.libelle}
                  name={proteine.libelle}
                />
                <label
                  htmlFor={proteine.libelle}
                  className={Classnames(matchAfterUrl(proteine.urlPicto), {
                    active: Array.from(this.props.recapAliments).includes(
                      proteine.libelle
                    ),
                  })}
                >
                  <span>{translateAlimentLibelle(proteine.libelle, this.props.t)}</span>
                </label>
              </div>
            ))}
            {proteineArray.length > 8 ? (
              <div className="col-md-4 px-2 autre-react">
                <input
                  type="radio"
                  className="d-none autre-react"
                  onClick={() =>
                    this.handleChange({
                      id: "autre-composant-repas",
                      name: "autre",
                    })
                  }
                  id="autre-composant-repas"
                  value="autre-composant-repas"
                  readOnly
                  checked={this.state.showMore}
                />
                <label
                  htmlFor="autre-composant-repas"
                  className={Classnames("autre-react plus-de-legumes", {
                    active: proteineArray
                      .slice(8)
                      .some((proteine) =>
                        Array.from(this.props.recapAliments).includes(
                          proteine.libelle
                        )
                      ),
                  })}
                >
                  <span className="autre-react">{t('modal_enfant.repas.other')}</span>
                </label>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.state.showMore ? (
            <div className="d-flex justify-content-center mt-4">
              <div className="btn-group recap-repas dropdown autre-plus">
                <button
                  onClick={() => {
                    this.openListAutre();
                  }}
                  type="button"
                  className="custom-input box-shadow btn-show-autre-repas dropdown-toggle autre-plus"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {t('modal_enfant.repas.more_proteines')}
                </button>
                {this.state.showListAutre ? (
                  <div
                    className="dropdown-menu box-shadow autre-plus"
                    style={{ display: "block" }}
                  >
                    <ul style={{ maxHeight: "195px" }} className="autre-plus">
                      {proteineArray.slice(8).map((proteine, index) => {
                        return (
                          <li
                            id={index}
                            className={Classnames("autre-plus", {
                              active: Array.from(
                                this.props.recapAliments
                              ).includes(proteine.libelle),
                            })}
                            key={index}
                            onClick={() => this.handleChangeList(proteine)}
                          >
                            <label
                              value={JSON.stringify(proteine)}
                              htmlFor={proteine.libelle}
                              className={Classnames("autre-plus", {
                                active: Array.from(
                                  this.props.recapAliments
                                ).includes(proteine.libelle),
                              })}
                              style={{ display: "inline" }}
                            >
                              <span className="autre-plus">
                                {translateAlimentLibelle(proteine.libelle, this.props.t)}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      return "";
    }
  }
}

export default withTranslation()(Proteines);
